import React from 'react'

import EditZoneForm from '../../modules/Zone/components/EditZoneForm'
export default function EditZonePage() {
  return <EditZoneForm />
}
